import { Button, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { IdentificationResultIcon } from '../../components/Icons';
import { ContentCard } from '../../layout/ContentCard';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import { PromotionsTable } from './PromotionsTable';

const PromotionOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:promotions.meta.title')} />
      <ContentCard
        icon={<IdentificationResultIcon boxSize={10} />}
        minH="fit-content"
        header={t('promotions:table.header')}
        data-test-id="promotions-overview-card"
      >
        <PromotionsTable />
        <Flex direction="row-reverse" mt="8">
          <Button variant="primary" as={RouterLink} to="/app/op/promotions/create">
            {t('common:create')}
          </Button>
        </Flex>
      </ContentCard>
    </ContentLayout>
  );
};

export default PromotionOverviewPage;
